export default {
  nav: {
    brand: "USFans Link",
    home: "Inicio",
    categories: "Categorías",
    guides: "Guías",
    faq: "FAQ",
    explore: "Explorar hoja de cálculo",
    shoppingGuide: "Guía de compras",
  },
  hero: {
    eyebrow: "Centro de recursos de USFans Spreadsheet",
    title: "Explora USFans Spreadsheet: categorías, guías y recursos",
    description:
      "Descubre un centro organizado sobre USFans Spreadsheet: navega por categorías de moda, lee guías prácticas, compara recursos y encuentra todo lo que necesitas en un solo lugar tranquilo y fácil de navegar.",
    trust: "Recurso independiente • Actualizado con regularidad • Fácil de navegar • Enfocado en la seguridad",
    searchPlaceholder: "Busca creadores, categorías, guías o temas...",
  },
  main: {
    usfansSpreadsheet: "USFans Spreadsheet",
    buyNow: "Comprar ahora",
  },
  dropdown: {
    label: "Ir a una categoría",
    placeholder: "Elige una categoría...",
  },
  categoriesSection: {
    title: "Explora las categorías",
    subtitle:
      "Descubre toda la gama de categorías de moda y estilo de vida, cada una enlazada a la sección correspondiente del sitio web principal.",
    browseAll: "Ver todas las categorías",
  },
  categories: {
    shoes: "Zapatos",
    hoodies: "Sudaderas/Jerséis",
    tshirts: "Camisetas",
    jackets: "Chaquetas",
    pants: "Pantalones/Shorts",
    headwear: "Gorras y sombreros",
    sets: "Conjuntos",
    underwear: "Ropa interior",
    jersey: "Camisetas deportivas",
    accessories: "Accesorios",
    bags: "Bolsos",
    belts: "Cinturones",
    perfumes: "Perfumes",
    other: "Otros",
  },
  what: {
    title: "¿Qué es USFans Spreadsheet?",
    p1: "USFans Spreadsheet es un recurso estructurado que facilita descubrir, comparar y entender la información relacionada con USFans. En lugar de buscar en páginas dispersas, puedes explorar categorías organizadas que cubren zapatos, sudaderas, chaquetas, accesorios y mucho más.",
    p2: "Funciona como un punto de partida amable: revisa la lista de categorías, elige lo que te interesa y sigue un enlace claro al sitio web principal cuando estés listo para ver más.",
    cta: "Aprende más sobre USFans Spreadsheet",
  },
  why: {
    title: "¿Por qué usar este recurso?",
    subtitle: "Una forma tranquila y organizada de navegar, pensada para la rapidez y la claridad.",
    c1title: "Información organizada",
    c1desc: "Las categorías están agrupadas para que encuentres la sección correcta en segundos.",
    c2title: "Descubrimiento fácil",
    c2desc: "Un menú desplegable simple y botones claros hacen que navegar sea sencillo.",
    c3title: "Comparaciones útiles",
    c3desc: "Ve las categorías una al lado de la otra para decidir qué explorar a continuación.",
    c4title: "Enfocado en la seguridad",
    c4desc: "Orientación clara para navegar y seguir enlaces con confianza.",
  },
  guides: {
    title: "Últimas guías",
    subtitle:
      "Artículos originales y prácticos sobre USFans Spreadsheet y cómo sacarle el máximo partido.",
    readMore: "Leer la guía",
    comingSoon: "Próximamente",
    comingTitle1: "USFans Review: qué debes saber",
    comingExcerpt1: "Una mirada más cercana a las funciones, pros, contras y consideraciones prácticas.",
    comingCategory1: "Reseña",
    comingTitle2: "Guía de costos de envío de USFans",
    comingExcerpt2: "Factores de envío, precios y consideraciones de entrega explicados.",
    comingCategory2: "Envío",
  },
  faq: {
    title: "Preguntas frecuentes",
    subtitle: "Respuestas rápidas a preguntas comunes sobre USFans Spreadsheet.",
    q1: "¿Qué es USFans Spreadsheet?",
    a1: "Es un recurso estructurado que agrupa categorías de moda y estilo de vida en una vista fácil de explorar, con enlaces claros al sitio web principal.",
    q2: "¿Cómo navego por las categorías?",
    a2: "Usa el menú desplegable o los botones de categorías de la página de inicio. Ambos llevan a la sección correspondiente del sitio web principal.",
    q3: "¿Es gratis usar USFans Spreadsheet?",
    a3: "Sí, la navegación es totalmente gratuita y no se necesita cuenta.",
    q4: "¿Con qué frecuencia se actualiza la información?",
    a4: "El recurso se actualiza con regularidad para mantener los enlaces de categorías precisos y al día.",
    q5: "¿A dónde llevan los enlaces de categorías?",
    a5: "Cada enlace lleva a la sección de categoría correspondiente del sitio web principal.",
    q6: "¿Cómo puedo mantenerme seguro al navegar?",
    a6: "Verifica la dirección del sitio, mantén privados los datos de acceso y pago, y evita compartir información personal con fuentes no confiables.",
  },
  cta: {
    title: "Empieza a explorar USFans Spreadsheet",
    desc: "Encuentra categorías organizadas, guías prácticas y recursos útiles en un solo lugar.",
    primary: "Explora USFans Spreadsheet",
    secondary: "Visita el sitio web principal",
  },
  footer: {
    about:
      "USFans Link es un centro de recursos independiente construido en torno a USFans Spreadsheet, que ayuda a los visitantes a navegar por categorías, leer guías y encontrar información útil.",
    quickLinks: "Enlaces rápidos",
    categories: "Categorías",
    resources: "Recursos",
    guides: "Guías",
    faq: "FAQ",
    home: "Inicio",
    rights: "Todos los derechos reservados.",
    disclaimer:
      "USFans Link es un recurso independiente y no está afiliado al sitio web principal. Los enlaces de productos llevan a la tienda oficial.",
  },
  notFound: {
    title: "Página no encontrada",
    desc: "La página que buscas no existe o se ha movido. Vuelve a la página de inicio para seguir navegando.",
  },
};